import { Controller } from '@hotwired/stimulus';

// Formulaire envoyé dès qu'un champ change (fichier choisi) ; `queue` :
// après une pause (date saisie au clavier, chiffre après chiffre).
export default class extends Controller {
    submit() {
        clearTimeout(this.timer);
        this.element.requestSubmit();
    }

    queue() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.element.requestSubmit(), 800);
    }

    disconnect() {
        clearTimeout(this.timer);
    }
}
